import React, { useContext } from 'react';

import MessagePanel from '../../common/components/MessagePanel/MessagePanel';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';

function TokenFrozenScreen(): JSX.Element {
  const { flowSuccessful } = useContext(FlowConfigContext);
  const onConfirm = () => {
    flowSuccessful();
  };

  return (
    <MessagePanel
      title="screens.tokenFrozen.title"
      description="screens.tokenFrozen.description"
      buttonLabel="screens.tokenFrozen.buttonLabel"
      onConfirm={onConfirm}
      showSupportLink
    />
  );
}
export default withRouteAnalytics(TokenFrozenScreen, Screens.TOKEN_FROZEN);
